import {extendTheme} from "@chakra-ui/react"

export const theme = extendTheme({
    colors: {
        zpurple: {
            100: "#af69e3",
            200: "#9f62cc",
            300: "#8a53b3",
            400: "#764799",
            500: "#623b80",
            600: "#4f2f66",
            700: "#3b234d",
            800: "#271833",
            900: "#1d1226",
        },
        zpink: {
            100: "#db75e6",
            200: "#c368cc",
            300: "#aa5bb3",
            400: "#924e99",
            500: "#794180",
            600: "#fff",
            700: "#fff",
            800: "#fff",
            900: "#fff",
        },
        zred: {
            100: "#f8a5a5",
            200: "#f79696",
            300: "#f68787",
            400: "#f57878",
            500: "#f46969",
            600: "#f35a5a",
            700: "#f14b4b",
            800: "#f03c3c",
            900: "#ef2d2d",
        }
    }
})